import type { FC, ReactNode } from "react";

import { mainBannerProvider } from "./MainBannerProvider";

export type MainBannerTranslations = {
  heading: {
    title: string;
  };
  buttons: {
    create: string;
    login: string;
  };
};

export const MainBannerTranslationProvider: FC<{
  value: MainBannerTranslations;
  children: ReactNode;
}> = (props) => {
  return (
    <mainBannerProvider.Provider value={props.value}>
      {props.children}
    </mainBannerProvider.Provider>
  );
};
